import { useMemo } from 'react'

import { useFeatureFlags } from '@/contexts/FeatureFlagsContext'
import { useBuySellStore } from '@/reducers/transactionReducer'
import {
  getSupportedCurrencies,
  NetworkValue,
  Networks,
  StableCoins,
  StableCoinValue,
} from '@/utils/currencies'
import { getIsCadcBlockedOnNetwork } from '@/utils/cadc'

export const useSupportedCurrencies = () => {
  const {
    enableCadcSolana,
    enableBase,
    enableSendNewCadc,
    enableRejectOldCadc,
    isLoading,
  } = useFeatureFlags()
  const transactionType = useBuySellStore.use.transactionType()

  return useMemo(() => {
    const currencies = getSupportedCurrencies(enableCadcSolana)
    const hideBase = !isLoading && !enableBase
    const withBase = hideBase
      ? { ...currencies, [Networks.base]: [] }
      : currencies

    return Object.fromEntries(
      Object.entries(withBase).map(([network, coins]) => [
        network,
        getIsCadcBlockedOnNetwork({
          network: network as NetworkValue,
          transactionType,
          enableSendNewCadc,
          enableRejectOldCadc,
        })
          ? coins.filter((coin) => coin !== StableCoins.CADC)
          : coins,
      ])
    ) as Record<NetworkValue, StableCoinValue[]>
  }, [
    enableCadcSolana,
    enableBase,
    enableSendNewCadc,
    enableRejectOldCadc,
    isLoading,
    transactionType,
  ])
}
